module.exports = __webpack_public_path__ + "static/media/icon-radio.16e3cef1.svg";